import { Store } from '../../../store';
import { ProductService } from '../../../services/product.service';
import { Component, Input, NgModule, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '../../../directives/directives.module';

@Component({
    selector: 'app-product-types-slider',
    templateUrl: './product-types-slider.component.html',
    styleUrls: ['./product-types-slider.component.scss']
})
export class ProductTypesSliderComponent implements OnInit {
    @Input() backgroundColour = 'bg-grey';

    slidesPerView = 4;
    showNav = true;
    productGroups = [];
    showOverflow = true;
    deviceType$ = this.store.select<string>('deviceType');

    constructor(
        private productsService: ProductService,
        private store: Store,
    ) {
    }

    ngOnInit(): void {
        const deviceType = this.store.selectForLocal('deviceType');

        if (deviceType === 'mobile') {
            this.slidesPerView = 1;
        }
        if (deviceType === 'tabletV') {
            this.slidesPerView = 2;
        }
        if (deviceType === 'tabletH') {
            this.slidesPerView = 4;
        }
        this.getProductGroups();
    }


    getProductGroups() {
        this.productsService.getProductGroups().subscribe(data => {
            this.productGroups = data.data;
            this.setSliderOptions();
        });
    }

    setSliderOptions() {
        const deviceType = this.store.selectForLocal('deviceType');

        if (deviceType === 'mobile') {
            this.slidesPerView = 1;
            this.showNav = false;
        }
        if (deviceType === 'tabletV') {
            this.slidesPerView = 2;
            this.showNav = false;
        }
        if (deviceType === 'tabletH') {
            this.slidesPerView = 4;
            this.showNav = false;
        }
        if (deviceType === 'desktop') {
            this.slidesPerView = 4;
            this.showNav = true;
        }

        if (this.productGroups.length <= this.slidesPerView) {
            this.showNav = false;
        }

    }


}


@NgModule({
    declarations: [ProductTypesSliderComponent],
    exports: [ProductTypesSliderComponent],
    imports: [
        CommonModule,
        SharedModule,
        RouterModule,
        DirectivesModule
    ]
})

export class ProductTypesSliderModule {
}
